'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResult = function SearchResult(_ref) {
  var image = _ref.image,
      subtitle = _ref.subtitle,
      title = _ref.title,
      url = _ref.url,
      button = _ref.button,
      cta = _ref.cta,
      classNames = _ref.classNames;
  return _react2.default.createElement(
    'li',
    { className: 'c11n-search-result ' + classNames.root },
    image && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('img', { src: image, alt: title, className: classNames.avatar })
    ),
    _react2.default.createElement(
      'div',
      { className: classNames.titles },
      _react2.default.createElement(
        'h4',
        { className: classNames.title },
        title
      ),
      subtitle && _react2.default.createElement(
        'h6',
        { className: classNames.subtitle },
        subtitle
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_button2.default, _extends({
        tag: 'a',
        href: url,
        'aria-label': cta,
        children: cta,
        target: '_blank',
        rel: 'noopener'
      }, button))
    )
  );
};

SearchResult.propTypes = {
  /**
   * Image URL
   */
  image: _propTypes2.default.string,

  /**
   * Name of the result to display
   */
  title: _propTypes2.default.string.isRequired,

  /**
   * Additional text to display below the title
   */
  subtitle: _propTypes2.default.string,

  /**
   * The URL for the page
   */
  url: _propTypes2.default.string,

  /**
   * Props to be passed into the button
   */
  button: _propTypes2.default.object,

  /**
   * The button text
   */
  cta: _propTypes2.default.string,

  /**
   * Custom styles to be applied
   */
  styles: _propTypes2.default.object
};

SearchResult.defaultProps = {
  cta: 'Support'
};

exports.default = (0, _withStyles2.default)(_styles2.default)(SearchResult);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/search-result/index.js
// module id = 244
// module chunks = 0